module.exports = __webpack_public_path__ + "img/p12.e3ecc1b0.png";